import { render, staticRenderFns } from "./AdBlockerBait.vue?vue&type=template&id=18a1ac16"
import script from "./AdBlockerBait.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdBlockerBait.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports